(ns journal-app-client.utils.react-fiber
  (:require [goog.object :as g]
            ["@react-three/fiber" :as react-fiber]
            ["@react-three/drei" :as react-drei]
            ["three" :as three]
            ["@react-spring/three" :as react-spring]
            [reagent.core :as r]))

(def canvas (r/adapt-react-class react-fiber/Canvas))
(def animated-mesh (r/adapt-react-class (.-mesh (.-animated react-spring))))
(def animated-mesh-standard-material (r/adapt-react-class (.-meshStandardMaterial (.-animated react-spring))))

(def double-side (.-DoubleSide three))

(def perspective-camera (r/adapt-react-class (.-PerspectiveCamera react-drei)))
(def orthographic-camera (r/adapt-react-class (.-OrthographicCamera react-drei)))
(def orbit-controls (r/adapt-react-class (.-OrbitControls react-drei)))
(def environment (r/adapt-react-class (.-Environment react-drei)))
(def html (r/adapt-react-class (.-Html react-drei)))
(def stats (r/adapt-react-class (.-Stats react-drei)))

(def drei-plane (r/adapt-react-class (.-Plane react-drei)))
(def drei-box (r/adapt-react-class (.-Box react-drei)))
(def drei-sphere (r/adapt-react-class (.-Sphere react-drei)))
(def drei-text (r/adapt-react-class (.-Text react-drei)))

(def use-frame react-fiber/useFrame)
(def use-three react-fiber/useThree)
(def use-spring react-spring/useSpring)

(def spring-config (.-config react-spring))

(defn use-gltf [src] (react-drei/useGLTF src))

(defn preload [src]
  (.preload react-drei/useGLTF src))